<template>
  <div>
    <!-- Overlays -->
    <LoadOverlay :show="boolLoading"/>
    <ScorePopUp v-model="showScore" :score="score"/>

    <!-- Main body -->
    <v-row justify="center">
      <v-col cols="9">

         <!-- Header/logo -->
        <v-row justify="center">
          <!-- <v-col cols="3">
            <a href="https://www.collaborationspharma.com/">
              <v-img src="Collab Logo extended white.png" height="20vh" class="collab-img"/>
            </a>
          </v-col> -->
          <!-- <v-col cols="6"> -->
          <v-col>
            <v-img src="MegaAChE.png" style="width:110px;height:110px;display:inline-block;vertical-align:middle;"/>
            <h1 style="display:inline-block;font-size:70pt;vertical-align:middle">MegaAChE</h1>
          </v-col>
          <!-- </v-col> -->
        </v-row>
        <br>

        <!-- Navigation bar -->
        <v-row justify="center">
          <v-col cols="12">
            <v-btn-toggle mandatory divided style="width:100%" v-model="modelNav" color="deep-purple">
              <v-btn style="width:50%" value="about">about</v-btn>
              <v-btn style="width:50%" value="predict">predict</v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>

        <!-- Main card -->
        <AboutCard v-if="selectedNav === 'about'"/>
        <PredictCard @loading="boolLoading = $event" v-if="selectedNav === 'predict'"
          @prediction="setPrediction($event)"/>

      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

import PredictCard from '../components/PredictCard.vue'
import AboutCard from '../components/AboutCard.vue'
import LoadOverlay from '../components/LoadOverlay.vue'
import ScorePopUp from '@/components/ScorePopUp.vue'

// Nav bar
const navOptions = [
  'about',
  'predict'
]
const selectedNav = ref(navOptions[0])
const modelNav = computed({
  get () {
    return selectedNav.value
  },
  set (value) {
    selectedNav.value = value
  }
})

const boolLoading = ref(false) // Loading model

// Prediction
const showScore = ref(false)
const score = ref({})

function setPrediction (value) {
  showScore.value = true
  score.value = value
}
</script>
